import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class ConnectTypes {
  static listMyConnects: IActionType = new ActionType('CONNECT/LIST_MY_CONNECT');
  static listConnect: IActionType = new ActionType('CONNECT/LIST_CONNECT');
  static listActionsConnect: IActionType = new ActionType('CONNECT/LIST_ACTIONS_CONNECT');
  static saveConnect: IActionType = new ActionType('CONNECT/SAVE_CONNECTS');
  static updateConnect: IActionType = new ActionType('CONNECT/UPDATE_CONNECT');
  static saveAction: IActionType = new ActionType('CONNECT/SAVE_CONNECT');
  static listTriggers: IActionType = new ActionType('CONNECT/LIST_CONNECT_TRIGGERS');
  static listConnectProduct: IActionType = new ActionType('CONNECT/LIST_CONNECT_PRODUCT');
  static listConnectOptions: IActionType = new ActionType('CONNECT/LIST_OPTIONS_CONNECT');
  static loadConnect: IActionType = new ActionType('CONNECT/LOAD_CONNECT');
  static loadAction: IActionType = new ActionType('CONNECT/LOAD_ACTION');
  static updateAction: IActionType = new ActionType('CONNECT/UPDATE_ACTION');
  static changeStatusConnect: IActionType = new ActionType('CONNECT/CHANGE_STATUS_CONNECT');
  static getActionFields: IActionType = new ActionType('CONNECT/GET_ACTION_FIELDS');
  static validateMailChimp: IActionType = new ActionType('CONNECT/VALIDATE_MAIL_CHIMP');
  static validateAweber: IActionType = new ActionType('CONNECT/VALIDATE_A_WEBER');
  static validateInfusion: IActionType = new ActionType('CONNECT/VALIDATE_A_INFUSION');
  static validateRDStation: IActionType = new ActionType('CONNECT/VALIDATE_RD_STATION');
}

export default ConnectTypes;
